import React from 'react'
import { Navigate } from 'react-router-dom'
function Protected({ isSignedIn, userType,path, children }) {
  if (!isSignedIn) {
    console.log(children)
    return <Navigate to="/" replace />
  }
  console.log(children)
  return children
}
export default Protected